class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}
